import {ApiResponse} from "../models/api-response.model";
import {apiDelete, apiGet, apiPost, apiPut} from "../utils/api.util";
import {LoginResponse} from "./auth.service";

export interface PasswordResetRequest {
    userId: number
    newPassword: string
    reason: string
}

export interface ChangePasswordRequest {
    username: string
    oldPassword: string
    newPassword: string
}

export interface SwitchCompanyRequest {
    companyId: number
}


export const resetPassword = async (request: PasswordResetRequest): Promise<ApiResponse<any>> => {
    const secureRequest = {
        ...request,
        newPassword: btoa(request.newPassword)
    };

    const response = await apiPost('/api/v1/common/user-account/reset-password', secureRequest, {});
    return await response.json();
};


export const changePassword = async (request: ChangePasswordRequest): Promise<ApiResponse<any>> => {
    const response = await apiPost('/api/v1/common/user-account/change-password', {
        ...request,
        oldPassword: btoa(request.oldPassword),
        newPassword: btoa(request.newPassword)
    }, {});
    return await response.json();
};

export const logoutUser = async (makeApiCall: boolean = false) => {
    try {
        if (makeApiCall) {
            await apiPost('/api/v1/common/user-account/logout', null, {});
        }
        return null;
    } catch (e) {
        return Promise.reject(e);
    }
};

export const switchCompany = async (request: SwitchCompanyRequest): Promise<ApiResponse<LoginResponse>> => {
    const response = await apiPost('/api/v1/common/user-account/switch-company', request, {});
    return await response.json();
}

export const uploadMySignature = async (signature: string): Promise<ApiResponse<any>> => {
    const response = await apiPut('/api/v1/common/user-account/my-signature', {signature}, {});
    return await response.json();
};

export const getMySignature = async (): Promise<ApiResponse<string>> => {
    const response = await apiGet('/api/v1/common/user-account/my-signature');
    return await response.json();
};

export const deleteMySignature = async (): Promise<ApiResponse<any>> => {
    const response = await apiDelete('/api/v1/common/user-account/my-signature');
    return await response.json();
};